import { initAccordion } from '../../components/accordion';

export default class CustomerReferralOkendo {
  elements;

  constructor() {

    this.elements = {

    };

    // Initialize the FAQ accordion
    this.initFAQ();
  }

  initFAQ = () => {
    if (!document.querySelectorAll('.customer-referral__faq').length) {
      return;
    }
    
    initAccordion('#CustomerReferralFAQ');
  };
}
